import { supabase } from "./supabase";

const visitSelect = "id, status, purpose, notes, expected_arrival, expected_departure, checked_in_at, checked_out_at, approval_required, equipment_declaration, induction_required, restricted_area, validity_start, validity_end, site_id, visitor_id, host_employee_id, visitor_type_id, contractor_company_id, visitors(first_name, last_name, email, phone, company), sites(name), employees(first_name, last_name), visitor_types(name, is_contractor)";

export function listVisits(orgId, filters = {}) {
  let query = supabase.from("visits").select(visitSelect).eq("organization_id", orgId).order("expected_arrival", { ascending: false }).limit(200);
  if (filters.status) query = query.eq("status", filters.status);
  if (filters.siteId) query = query.eq("site_id", filters.siteId);
  if (filters.typeId) query = query.eq("visitor_type_id", filters.typeId);
  if (filters.hostId) query = query.eq("host_employee_id", filters.hostId);
  return query;
}

export function getVisit(id) {
  return supabase.from("visits").select(visitSelect).eq("id", id).maybeSingle();
}

export function getHistory(visitId) {
  return supabase.from("visit_status_history").select("id, from_status, to_status, source, comment, created_at").eq("visit_id", visitId).order("created_at");
}

export function createPreregistration(payload) {
  return supabase.rpc("create_preregistration", { p_payload: payload });
}

export function decideApproval(approvalId, decision, comment) {
  return supabase.rpc("decide_approval", { p_approval_id: approvalId, p_decision: decision, p_comment: comment });
}

export function checkOut(visitId) {
  return supabase.rpc("check_out_visit", {
    p_visit_id: visitId,
    p_idempotency_key: `portal-${visitId}-${Date.now()}`,
    p_channel: "portal",
  });
}

export async function dispatchNotification(notificationId) {
  return supabase.functions.invoke("dispatch-email", { body: { notification_id: notificationId } });
}

export async function dispatchVisitNotifications(visitId) {
  const { data, error } = await supabase
    .from("notifications")
    .select("id, status, template_key")
    .eq("related_visit_id", visitId)
    .in("status", ["queued", "failed", "unconfigured"]);
  if (error) return { error };
  const results = [];
  for (const row of data || []) {
    results.push(await dispatchNotification(row.id));
  }
  return { data: results };
}

export function listVisitNotifications(visitId) {
  return supabase
    .from("notifications")
    .select("id, template_key, recipient, status, sent_at, delivered_at, failed_at, created_at, last_event_type")
    .eq("related_visit_id", visitId)
    .order("created_at", { ascending: false });
}

export function resendInvitation(invitationId) {
  return supabase.rpc("resend_invitation", { p_invitation_id: invitationId });
}

export function toCsv(rows) {
  if (!rows.length) return "";
  const headers = Object.keys(rows[0]);
  const lines = [headers.join(",")];
  rows.forEach((row) => {
    lines.push(headers.map((key) => `"${String(row[key] ?? "").replaceAll('"', '""')}"`).join(","));
  });
  return lines.join("\n");
}
